<template>
  <div class="inputView" v-cloak>
      <img src="gzh.png" class="imageStyle" />
  </div>
</template>
<style>
.inputView {
  background-color: #54B7B9;
}
.detailView {
  margin: 10px;
  color: #000000;
  font-size: 10px;
  display: flex;
  justify-content: center;
  border-radius:10px;
}
.btnView {
  height: 40px;
  margin: 20px;
  background-color: #e93323;
  color: #fff;
  font-size: 20px;
  display: flex;
  justify-content: center;
  border-radius:10px;
}
.syTitle {
  margin-top: 10px;
  /* background-color: #e93323; */
  color: #000000;
  font-size: 20px;
}
.mask {
  -webkit-filter: blur(2px);
  -moz-filter: blur(2px);
  -ms-filter: blur(2px);
  filter: blur(2px);
}
.footer .icon-shoucang1 {
  color: #e93323;
}
.product-con .product-intro .conter div {
  width: 100% !important;
}
.generate-posters {
  width: 100%;
  height: 1.7rem;
  background-color: #fff;
  position: fixed;
  left: 0;
  bottom: 0;
  z-index: 99;
  transform: translate3d(0, 100%, 0);
  -webkit-transform: translate3d(0, 100%, 0);
  -ms-transform: translate3d(0, 100%, 0);
  -moz-transform: translate3d(0, 100%, 0);
  -o-transform: translate3d(0, 100%, 0);
  transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
  -webkit-transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
  -moz-transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
  -o-transition: all 0.3s cubic-bezier(0.25, 0.5, 0.5, 0.9);
}
.generate-posters.on {
  transform: translate3d(0, 0, 0);
  -webkit-transform: translate3d(0, 0, 0);
  -ms-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
  -o-transform: translate3d(0, 0, 0);
}
.generate-posters .item {
  flex: 50%;
  -webkit-flex: 50%;
  -ms-flex: 50%;
  text-align: center;
}
.generate-posters .item .iconfont {
  font-size: 0.8rem;
  color: #5eae72;
}
.generate-posters .item .iconfont.icon-haibao {
  color: #5391f1;
}
.imageStyle {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>
<script>


import {
  getOrderInfo,
  getProductDetail,
  getOpenId,
  getSchoolList,
  getGradeList,
  getClassesList
} from "@api/public";


import { isWeixin } from "@utils/index";
import { mapGetters } from "vuex";
import { log } from 'util';
import { Toast } from 'vant';
import { Checkbox, CheckboxGroup } from 'vant';
import { pay , oAuth, wechat} from "@libs/wechat";
import { parseQuery } from "@utils/index";
import cookie from "@utils/store/cookie";

import { Loading } from 'vant';
import { Field } from 'vant';
import { Button, Popup, Picker } from 'vant';


import { wechatConfigBuy} from "@libs/wechat";

export default {
  name: "GoodsCon",
  components: {
    [Loading.name]:Loading,
    [Field.name]:Field,
    [Button.name]:Button,
    [Popup.name]:Popup,
    [Picker.name]:Picker,
    Toast,
  },
  data: function() {
    return {
      showPickerSchool: false,
      showPickerClass: false,
      showPickerSubClass: false,

      schoolColumns: [],
      gradeColumns: [],
      classesColumns: [],

      schoolIdList: [],
      gradeIdList: [],
      classesIdList: [],

      checked: true,
      title: "",
      price: "",
      detail: "",
      grade: "",
      gradeId: "",
      classes: "",
      classesId: "",
      phone: "",
      school: "",
      schoolId: "",
      userName: "",
      tradeImageList:[]
    };
  },
  computed: mapGetters(["isLogin"]),
  mounted: function() {
    
  },
  methods: {

    onConfirmSchool(value) {
      this.school = value;
      this.showPickerSchool = false;
      for (let index = 0; index < this.schoolColumns.length; index++) {
        const element = this.schoolColumns[index];
        if (element == this.school) {
          this.schoolId = this.schoolIdList[index];
          break;
        }
        
      }

      this.getGradeListMem();
    },
    onConfirmGrade(value) {
      this.grade = value;
      this.showPickerClass = false;

       for (let index = 0; index < this.gradeColumns.length; index++) {
        const element = this.gradeColumns[index];
        if (element == this.grade) {
          this.gradeId = this.gradeIdList[index];
          break;
        }
        
      }

      this.getClassesListMem();
    },
    onConfirmClass(value) {
      this.classes = value;
      this.showPickerSubClass = false;

      for (let index = 0; index < this.classesColumns.length; index++) {
        const element = this.classesColumns[index];
        if (element == this.classes) {
          this.classesId = this.classesIdList[index];
          break;
        }
        
      }
    },
    //产品详情接口；
    buyProductCon: function() {
      let that = this;

      const {price, grade, phone, school, userName, classes, classesId, gradeId, schoolId} = that;

      if (grade.length < 1) {
        that.$dialog.error("班级未填写");
        return;
      }
      if (phone.length < 1) {
        that.$dialog.error("手机未填写");
        return;
      }
      if (school.length < 1) {
        that.$dialog.error("学校未选择");
        return;
      }
      if (userName.length < 1) {
        that.$dialog.error("姓名未选择");
        return;
      }
      if (classes.length < 1) {
        that.$dialog.error("班级未选择");
        return;
      }

      function isPoneAvailable(phone) {
            var myreg=/^[1][3,4,5,7,8][0-9]{9}$/;
            if (!myreg.test(phone)) {
                return false;
            } else {
                return true;
            }
        }

      if (isPoneAvailable(phone) == false) {
        that.$dialog.toast({ mes: "请输入正确手机号!!" });
        return;
      }

      // that.$dialog.toast({ mes: "open id "+this.openId });
      
      getOrderInfo(that.openId, that.productId, that.unionId, price, userName, phone, classes, classesId, grade, gradeId, school, schoolId)
        .then(res => {
          log(res);
          if (res.code == 0) {
              pay(res.data)
              .finally(() => {
                that.$dialog.toast({ mes: "支付成功" });
              })
              .catch(function() {
                that.$dialog.toast({ mes: "支付失败" });
              });
          } else{
            log("code --"+res.code);
              that.$dialog.toast({ mes: res.msg });
          }

        
        })
        .catch(res => {
        });
    },
    
    getProductInfo: function() {

       let that = this;
      getProductDetail(that.productId)
        .then((res) => {
          that.$set(that, "tradeImageList", res.data.img);
          that.$set(that, "title", res.data.name);
          that.$set(that, "price", res.data.price);
          that.$set(that, "detail", res.data.desc);
        })
        .catch(res => {
          // that.$dialog.error(res.msg);
          // that.$router.go(-1);
        });
      
    },
    getSchoolListMem: function() {

      let that = this;
      getSchoolList(that.productId)
        .then((res) => {
          log(res.data);

          for (let index = 0; index < res.data.length; index++) {
            const element = res.data[index];
            log(element.name);
            that.schoolColumns.push(element.name);
            log(element.id);
            that.schoolIdList.push(element.id);
            
          }
        })
        .catch(res => {
          // that.$dialog.error(res.msg);
          // that.$router.go(-1);
        });
      
    },
    getGradeListMem: function() {

      let that = this;
      getGradeList(that.schoolId)
        .then((res) => {
          log(res.data);

          for (let index = 0; index < res.data.length; index++) {
            const element = res.data[index];
            log(element.name);
            that.gradeColumns.push(element.name);
            log(element.id);
            that.gradeIdList.push(element.id);
            
          }
        })
        .catch(res => {
          // that.$dialog.error(res.msg);
          // that.$router.go(-1);
        });
      
    },
    getClassesListMem: function() {

      let that = this;
      getClassesList(that.gradeId)
        .then((res) => {
          log(res.data);

          for (let index = 0; index < res.data.length; index++) {
            const element = res.data[index];
            log(element.NAME);
            that.classesColumns.push(element.NAME);
            log(element.id);
            that.classesIdList.push(element.id);
            
          }
        })
        .catch(res => {
          // that.$dialog.error(res.msg);
          // that.$router.go(-1);
        });
      
    },
  }
};
</script>
